'use client';

import React from 'react';

// eslint-disable-next-line no-restricted-imports
import Link from 'next/link';
import { cn } from '@/utils/cn';
import { isExternalLink } from './utils/is-external-link';
type CustomNextLinkProps = React.PropsWithChildren & {
  href: string;
  prefetch?: boolean;
  className?: string;
  key?: string | number | null;
  'aria-label'?: string;
  dir?: 'ltr' | 'rtl';
  target?: '_blank' | '_parent' | '_self' | '_top';
  onClick?: (e: React.MouseEvent) => void;
};
export const AppNextLink = React.forwardRef<HTMLAnchorElement, CustomNextLinkProps>(({
  href,
  children,
  onClick,
  prefetch = false,
  className,
  dir,
  'aria-label': ariaLabel,
  target
}, ref) => {
  const isEmptyLink = href === '#';
  const isExternal = isExternalLink(href);
  if (isExternal) {
    return <div role='button' ref={ref as React.Ref<HTMLDivElement>} onClick={e => {
      onClick?.(e);
      setTimeout(() => {
        window.open(href, '_blank');
      }, 200);
    }} className={`cursor-pointer ${className}`} aria-label={ariaLabel} dir={dir}>
                    {children}
                </div>;
  }
  return <Link href={href} prefetch={prefetch} className={cn({
    'cursor-default': isEmptyLink
  }, className)} onClick={e => {
    if (isEmptyLink) e.preventDefault();
    onClick?.(e);
  }} ref={ref} dir={dir} aria-label={ariaLabel} target={target}>
                {children}
            </Link>;
});
AppNextLink.displayName = 'AppNextLink';